import Row from '@amzn/meridian/row';
import Tag from '@amzn/meridian/tag';
import React, { FC, useState } from 'react';
import { TranslationFunction } from '../blocks';
import Button from '../blocks/localization/Button';

export interface FilterTag {
    label: string;
    key: string;
    remove: () => void;
}

interface FilterTagsProps {
    tags: FilterTag[];
    maxVisible?: number;
    t: TranslationFunction;
}

export const FilterTags: FC<FilterTagsProps> = ({ tags, maxVisible = 3, t }) => {
    const [showAll, setShowAll] = useState(false);

    if (tags.length === 0) return null;

    const visibleTags = showAll ? tags : tags.slice(0, maxVisible);
    const hiddenCount = tags.length - visibleTags.length;

    return (
        <Row spacing={'small'} wrap={'down'} alignmentVertical={'center'}>
            {visibleTags.map((tag) => (
                <Tag key={tag.key} onClose={tag.remove}>
                    {tag.label}
                </Tag>
            ))}
            {hiddenCount > 0 && (
                <Button type={'link'} onClick={() => setShowAll(true)}>
                    {t('showMore-button', { count: hiddenCount })}
                </Button>
            )}
            {showAll && tags.length > maxVisible && (
                <Button type={'link'} onClick={() => setShowAll(false)}>
                    {t('showLess-button')}
                </Button>
            )}
        </Row>
    );
};
